import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';
import type { Clinic } from './clinicQueries';

export interface CreateClinicRequest {
  name: string;
}

export interface UpdateClinicRequest {
  id: number;
  name: string;
}

export const createClinicMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.clinics.create(),
    mutationFn: async (values: CreateClinicRequest) => {
      return await api.post('clinics', { json: values }).json<Clinic>();
    },
    onSuccess: () => {
      toast.success('Clinic created successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to create clinic');
    },
  });
};

export const updateClinicMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.clinics.update(),
    mutationFn: async ({ id, name }: UpdateClinicRequest) => {
      return await api.put(`clinics/${id}`, { json: { name } }).json<Clinic>();
    },
    onSuccess: () => {
      toast.success('Clinic updated successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to update clinic');
    },
  });
};

export const deleteClinicMutation = () => {
  return mutationOptions({
    mutationKey: mutationKeys.clinics.delete(),
    mutationFn: async (id: number) => {
      return await api.delete(`clinics/${id}`).json<void>();
    },
    onSuccess: () => {
      toast.success('Clinic removed successfully');
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to remove clinic');
    },
  });
};
